/**
 * Registers dayjs plugins once for the whole app.
 *
 * dayjs plugins mutate the shared dayjs singleton, so importing this module
 * for its side effect at app startup makes `dayjs.utc()`, `dayjs.tz()` and
 * `dayjs().isoWeek()` available everywhere — including files that import a
 * bare `dayjs` without registering plugins themselves (e.g. Success.jsx,
 * which caused ORDER-THISWAY-1X: "TypeError: ee.utc is not a function").
 */
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import isoWeek from 'dayjs/plugin/isoWeek';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(isoWeek);

export default dayjs;
